export default "__VITE_ASSET__7rJYdqhp__"